export default "__VITE_ASSET__jpEGr89U__"